import { KTIcon } from "../../../../_metronic/helpers";

const ListingModalHeader = ({
  selectedPromo,
  setSelectedPromo,
  setOpenListingModal
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div>
      <h2 className="fw-bolder">{`Listings Assigned to Promo Code #${selectedPromo?.code}`}</h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setSelectedPromo(null);
          setOpenListingModal(false);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { ListingModalHeader };
